import React from 'react';

class Talisman extends React.Component {
    render() {
        return <img className="img-responsive meditating-girl" src="/img/meditating-girl.png" width="385" alt=""/>
    }
}

export default Talisman;




// WEBPACK FOOTER //
// ./src/components/Presentation/Talisman.js